import PropTypes from 'prop-types';

const onboardingPropTypes = {
  moveDate: PropTypes.string,
  setMoveDate: PropTypes.func,
  redirectUrl: PropTypes.string,
  setRedirectUrl: PropTypes.func,
  mpan: PropTypes.string,
  setMpan: PropTypes.func,
  termsAndConditions: PropTypes.string,
  setTermsAndConditions: PropTypes.func,
  lookedUpMpan: PropTypes.string,
  setLookedUpMpan: PropTypes.func,
  method: PropTypes.string,
  setMethod: PropTypes.func,
  paymentMethodId: PropTypes.string,
  setPaymentMethodId: PropTypes.func,
  consentFlow: PropTypes.oneOf(['onboarding', 'reconfirm']),
  setConsentFlow: PropTypes.func,
  showDeleteAccountModal: PropTypes.bool,
  setShowDeleteAccountModal: PropTypes.func,
  isDeleting: PropTypes.bool,
  setIsDeleting: PropTypes.func,
  deleteError: PropTypes.string,
  setDeleteError: PropTypes.func,
  showAlert: PropTypes.bool,
  setShowAlert: PropTypes.func,
  alert: PropTypes.string,
  setAlert: PropTypes.func,
};
export default onboardingPropTypes;
